export default {
    workOrder_createEdit_createTitle: "Create New Work Order",
    workOrder_createEdit_editTitle: "Edit Work Order",
    workOrder_createEdit_settings: "Settings",
    workOrder_createEdit_comments: "Comments",
    workOrder_createEdit_historyLogs: "History Logs",
    workOrder_createEdit_warning: "Warning!",
    workOrder_createEdit_warningMessage: "Are you sure you want to close the work order editor? Any unsaved changes will be lost",
};